import { FC } from "react";
import type { NotificationType } from "entities/notification";
import { useMarkAllNotificationsReadMutation } from "../api/readNotificationsApi";

import styles from "./MarkAllReadButton.module.css";

interface Props {
  // Без type помечает прочитанными все разделы.
  type?: NotificationType;
  disabled?: boolean;
}

export const MarkAllReadButton: FC<Props> = ({ type, disabled }) => {
  const [markAllRead, { isLoading }] = useMarkAllNotificationsReadMutation();

  return (
    <button
      type="button"
      className={styles.button}
      disabled={disabled || isLoading}
      onClick={() => markAllRead(type)}
    >
      Mark all as read
    </button>
  );
};
